import React from 'react';
import {FieldAccessContainer} from '../../Containers/PermissionControlsContainer';

const FieldAccess = (props) => {
	return (
		<FieldAccessContainer action="show" show=""/>
	);
}

export default FieldAccess;